// =============================================================================
// services/api/schedule.js
// =============================================================================
// Domain module for ApiService.  Import and register in api.service.js:
//
//   import scheduleApi from '@/services/api/schedule'
//   ApiService.schedule = scheduleApi
//
// All methods use ApiService.{verb}T() so the tenant prefix is injected
// automatically from the Vuex store (same pattern as device.js, dispenser.js).
// =============================================================================

import ApiService from '@/services/api.service'

const scheduleApi = {
  // List schedules — status defaults to "active" on the backend
  all(status = 'active') {
    return ApiService.getT(`schedule?status=${status}`)
  },

  // Lightweight badge counts
  summary() {
    return ApiService.getT('schedule/summary')
  },

  // Single schedule with full device_entries
  get(scheduleId) {
    return ApiService.getT(`schedule/${scheduleId}`)
  },

  // Create
  create(data) {
    return ApiService.postT('schedule', data)
  },

  // Edit name / mode / deadline_days
  update(scheduleId, data) {
    return ApiService.putT(`schedule/${scheduleId}`, data)
  },

  // Cancel
  cancel(scheduleId) {
    return ApiService.postT(`schedule/${scheduleId}/cancel`)
  },

  // Manually trigger one device entry (manual-mode schedules only)
  triggerDevice(scheduleId, deviceId) {
    return ApiService.postT(`schedule/${scheduleId}/device/${deviceId}/trigger`)
  },
}

export default scheduleApi